import React, { useEffect, useRef, useState } from "react";
import LoadingSpinner from "../Shared/LoadingSpinner/LoadingSpinner";
import Sidebar from "../Shared/Sidebar/Sidebar";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./ContactMe.css";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import emailjs from "@emailjs/browser";
import { FaEnvelope } from "react-icons/fa";
import { FaPhoneAlt } from "react-icons/fa";
import { FaHome } from "react-icons/fa";

const ContactMe = () => {
  const [loading, setLoading] = useState(true);
  const form = useRef();

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2500);
  }, []);

  const handleEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_x1pagvs",
        "template_lccngqf",
        form.current,
        "R4Pq26z5upZQJU1us"
      )
      .then(
        (result) => {
          toast.success("Email has been sent!", {
            position: "bottom-right",
            theme: "dark",
          });
          e.target.reset();
        },
        (error) => {
          toast.error("something went wrong!", {
            position: "bottom-right",
            theme: "dark",
          });
        }
      );
  };

  return (
    <section>
      <Sidebar></Sidebar>

      {loading ? (
        <LoadingSpinner></LoadingSpinner>
      ) : (
        <div className="lg:pl-[220px] ">
          <div className="lg:pl-20 w-full min-h-screen">
            <div className="grid grid-cols-1 gap-x-16 gap-y-10 lg:grid-cols-2">
              <div className="px-4 lg:px-0 py-6 lg:py-12 flex items-center w-full">
                <div>
                  <h1 className="mb-10 title-text mt-14 animate__animated animate__fadeInDown text-4xl lg:text-[55px] font-bold text-[#04BF00] tracking-[.07em]">
                    Contact{" "}
                    <span className="text-dark-blue-xxl dark:text-white">
                      Me
                    </span>
                  </h1>
                  <div className="form-text">
                    <form ref={form} onSubmit={handleEmail}>
                      <div className="mb-5 flex animate__animated animate__fadeInUp">
                        <input
                          type="text"
                          placeholder="Name"
                          name="name"
                          id=""
                          required
                          className="mr-5 w-full p-3 dark:bg-[#07101f] border-b-2 border-transparent text-dark-blue-xxl dark:text-white border-dark-blue-xxl dark:border-transparent focus:border-[#04BF00] dark:focus:border-[#04BF00] focus:outline-none"
                        />
                        <input
                          type="email"
                          placeholder="Email"
                          name="email"
                          id=""
                          required
                          className="w-full p-3 dark:bg-[#07101f] border-b-2 border-transparent text-dark-blue-xxl dark:text-white border-dark-blue-xxl dark:border-transparent focus:border-[#04BF00] dark:focus:border-[#04BF00] focus:outline-none"
                        />
                      </div>
                      <input
                        type="text"
                        placeholder="Subject"
                        name="subject"
                        id=""
                        required
                        className=" mb-5 w-full animate__animated animate__fadeInUp p-3 dark:bg-[#07101f] border-b-2 border-transparent text-dark-blue-xxl dark:text-white border-dark-blue-xxl dark:border-transparent focus:border-[#04BF00] dark:focus:border-[#04BF00] focus:outline-none"
                      />
                      <textarea
                        className="w-full animate__animated animate__fadeInUp mb-4 p-3 dark:bg-[#07101f] border-b-2 border-transparent text-dark-blue-xxl dark:text-white border-dark-blue-xxl dark:border-transparent focus:border-[#04BF00] dark:focus:border-[#04BF00] focus:outline-none"
                        name="message"
                        placeholder="Your Message"
                        cols={"42"}
                        rows={"8"}
                        required
                      ></textarea>

                      <div className="flex justify-center">
                        <input
                          className="block px-14 ring-1 animate__animated animate__fadeInUp ring-gray-700 hover:ring-[#04BF00] dark:ring-[#04BF00] py-3 bg-dark-blue-xxl dark:bg-dark-blue-xxl dark:hover:bg-[#04BF00] hover:bg-[#04BF00] hover:cursor-pointer"
                          type="submit"
                          value="SEND"
                        />
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div className="h-screen contact-map">
                <div className="contact-details bg-dark-blue-xxl dark:bg-dark-blue-xxl py-6 px-10 space-y-2">
                  <h4 className="form-text text-2xl font-bold mb-4">
                    Ishtiyak Ali Rifat
                  </h4>
                  <div className="space-y-2">
                    <div className="flex items-center space-x-3">
                      <FaHome size={"1.2em"} className="text-primary"></FaHome>
                      <h4 className="form-text">
                        Block F, Road 14, Bashundhara R/A
                      </h4>
                    </div>
                    {/* <div className="flex items-center space-x-3">
                      <FaBuilding size={"1.2em"}></FaBuilding>
                      <h4 className="form-text">Dhaka, Bangladesh</h4>
                    </div> */}
                    <div className="flex items-center space-x-3">
                      <FaPhoneAlt
                        size={"1.2em"}
                        className="text-primary"
                      ></FaPhoneAlt>
                      <h4 className="form-text">+880 1734446466</h4>
                    </div>
                    <div className="flex items-center space-x-3">
                      <FaEnvelope
                        size={"1.2em"}
                        className="text-primary"
                      ></FaEnvelope>
                      <h4 className="form-text">rifatishtiyak@gmail.com</h4>
                    </div>
                  </div>
                </div>
                <MapContainer
                  style={{ height: "100vh", width: "100%" }}
                  center={[23.825192, 90.431382]}
                  zoom={14}
                  scrollWheelZoom={false}
                  className="z-30"
                >
                  <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                  <Marker position={[23.819306, 90.431546]}>
                    <Popup>
                      <span className="text-xl">
                        <span className="font-bold text-[#04BF00]">
                          Ishtiyak
                        </span>
                        <span className="text-dark-blue-xxl"> lives here</span>
                        <span className="font-bold text-[#04BF00]"> 🙋‍♂️</span>
                      </span>
                    </Popup>
                  </Marker>
                </MapContainer>
              </div>
            </div>
          </div>
        </div>
      )}
      <ToastContainer />
    </section>
  );
};

export default ContactMe;
